import { render, staticRenderFns } from "./AbsComponent.vue?vue&type=template&id=1c05f460&"
import script from "./AbsComponent.vue?vue&type=script&lang=js&"
export * from "./AbsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports